<template>
  <app-page v-if="tescoPortalStubsEnabled" title="Support Analytics" icon="life-ring" class="analytics-support">
    <template #header>
      <divisions-dropdown />
    </template>
    <template #custom-content>
      <b-col>
        <analytics-nav />
        <support-metrics />
      </b-col>
    </template>
  </app-page>
  <app-page v-else title="Page Not Found" icon="exclamation-triangle">
    <template #custom-content>
      <b-col>
        <div class="text-center mt-5">
          <h3>Page Not Available</h3>
          <p class="text-muted">This page is not available for your account.</p>
          <b-button variant="primary" to="/analytics">Go to Analytics</b-button>
        </div>
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import AppPage from '@/components/AppPage.vue';
import SupportMetrics from '@/pages/analyticsApp/components/SupportMetrics.vue';
import AnalyticsNav from '@/pages/analyticsHomepage/components/AnalyticsNav.vue';
import DivisionsDropdown from '@/pages/analyticsHomepage/components/DivisionsDropdown.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';

const { tescoPortalStubsEnabled } = useFeatureFlags();
</script>
